import styled from '@emotion/styled';
import { css } from '@emotion/core';
import MuiErrorIcon from '@material-ui/icons/Error';
import MuiWarningIcon from '@material-ui/icons/Warning';
import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

const iconStyles = css`
  margin: 2px 14px 0 6px;
  height: 20px;
  width: 20px;
`;

export const ErrorIcon = styled(MuiErrorIcon)`
  color: ${COLORS.errorRed};
  ${iconStyles};
`;

export const WarningIcon = styled(MuiWarningIcon)`
  color: ${COLORS.shadow5};
  ${iconStyles};
`;

export const Container = styled.div`
  display: flex;
  padding: ${spacing.xSmall};
  border-radius: 4px;
  background-color: ${({ type }) =>
    type === 'error' ? COLORS.errorBg : COLORS.warningBg};
  color: ${({ type }) => (type === 'error' ? COLORS.black : COLORS.shadow6)};
`;

export const Content = styled.div`
  text-align: left;
  align-self: center;
`;
